import { API_URL } from './constants'
import { ApiError, apiRequest } from './client'

export const historyApi = {
    getExportHistory: () => apiRequest('/export/history'),

    getAuditLog: () => apiRequest('/audit-log?limit=200'),

    getVersions: () => apiRequest('/versions'),

    getVersionData: (versionId, table) =>
        apiRequest(`/versions/${encodeURIComponent(versionId)}/data/${encodeURIComponent(table)}`),

    generateSchedule: async () => {
        const response = await fetch(
            'https://schedule.guap.ru:8080/api/schedule/generate/term?term=1',
            {
                method: 'POST',
                credentials: 'include',
            }
        )

        if (!response.ok) {
            throw new ApiError('Ошибка генерации расписания', response.status)
        }

        return response.json().catch(() => null)
    },
}

export const getExportDownloadUrl = (key) =>
    `${API_URL}/export/download?key=${encodeURIComponent(key)}`
